module.exports = __webpack_public_path__ + "media/images/c-paginate/prev-667287efc7f6f91fa0ef48a1545b5b99.svg";